module.exports = __webpack_public_path__ + "img/extend-logo.90c33b2a.png";